/**
 * listing redux constants
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// redux action IDs
export const FETCH_OBJECT_QUERY             = 'FETCH_OBJECT_QUERY';
export const DELETE_OBJECT                  = 'DELETE_OBJECT';
export const UNDELETE_OBJECT                = 'UNDELETE_OBJECT';
export const UPDATE_SEARCH_INPUT            = 'UPDATE_SEARCH_INPUT';
